import { isNetworkError } from "@ronin/api-client";
import { toast } from "@ronin/ui";

/**
 * spec11 FR14: what failed, in words. Without a connection: "No connection: the todo was not
 * saved. Try again when you are online." Never "Failed to fetch" or a status code.
 */
export function errorMessage(error: unknown, what: string, verb = "saved"): string {
  if (isNetworkError(error)) {
    return `No connection: ${what} was not ${verb}. Try again when you are online.`;
  }
  return error instanceof Error ? error.message : "Something went wrong. Please try again.";
}

/** A mutation's `onError`: the message above as an error toast. */
export const showError =
  (what: string, verb?: string) =>
  (error: unknown): void =>
    void toast.error(errorMessage(error, what, verb));

/**
 * A query that has nothing to show because the server cannot be reached: it failed with a
 * network error, or TanStack Query paused it because the device is offline.
 */
export function needsConnection(query: {
  data: unknown;
  error: unknown;
  fetchStatus: string;
}): boolean {
  if (query.data !== undefined) return false;
  return query.fetchStatus === "paused" || isNetworkError(query.error);
}
